import type { ActionContext, ActionTree } from 'vuex';
import { RootState } from '@/store/modules/types';
import { PromoterTasksState } from './types';
import PromoterTaskFetcher from '@audience-republic/audience-manager-shared/store/modules/promoterTasks/PromoterTaskFetcher';
import type { PromoterIntegrationTask } from '@audience-republic/audience-manager-shared/api/promoter-integration-task/types';
import type { PromoterIntegrationTaskApi } from '@audience-republic/audience-manager-shared/api/promoter-integration-task';

class Am2PromoterTaskFetcher extends PromoterTaskFetcher {
  private context: ActionContext<PromoterTasksState, RootState>;

  constructor (promoterIntegrationTask: PromoterIntegrationTaskApi, context: ActionContext<PromoterTasksState, RootState>) {
    super(promoterIntegrationTask);
    this.context = context;
  }

  getAuthPromoterOid (): number | undefined {
    return this.context.rootState.auth.account?.promoterOid;
  }

  setPending (tasks: PromoterIntegrationTask[]): void {
    this.context.commit('SET_PENDING_TASKS', tasks);
  }

  setCompleted (tasks: PromoterIntegrationTask[]): void {
    this.context.commit('SET_COMPLETED_TASKS', tasks);
  }

  get interval (): number | null {
    return this.context.state.interval;
  }

  set interval (value: number | null) {
    this.context.commit('SET_INTERVAL', value);
  }

  get isFetching (): boolean {
    return this.context.state.isFetchingTasks;
  }

  set isFetching (value: boolean) {
    this.context.commit('SET_IS_FETCHING_TASKS', value);
  }
}

export const promoterTasksActions: ActionTree<PromoterTasksState, RootState> = {
  async START_POLLING_PENDING_TASKS (context) {
    await new Am2PromoterTaskFetcher(this.$api.promoterIntegrationTask, context).start();
  },
  STOP_TASK_POLLING (context) {
    new Am2PromoterTaskFetcher(this.$api.promoterIntegrationTask, context).stop();
  }
};
